import { Pipe, PipeTransform } from '@angular/core';
import twemoji from 'twemoji';

@Pipe({
  name: 'emoji',
  pure: true,
  standalone: false,
})
export class EmojiPipe implements PipeTransform {
  transform(value: string = '❓'): string {
    return twemoji.parse(value, {
      folder: 'svg',
      ext: '.svg',
      base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@latest/assets/'
    });
  }
}
